export default "__VITE_ASSET__CRWjwx7D__"